import React from 'react';
import Label from '../../auth/components/Label';
import {FormattedMessage} from 'react-intl';

export default ({id, required}) => {
    return <Label><FormattedMessage id={id}/> {required && <span className={"text-danger"}>*</span>}</Label>
}
